<div class="page-container">
  <div class="page-title-section">
    <h1><mat-icon>inventory_2</mat-icon> Estoque Michelin</h1>
    <p class="page-subtitle">Consulte os produtos disponíveis no estoque Michelin</p>
  </div>

  <!-- Filters -->
  <div class="filter-section">
    <div class="filter-header">
      <mat-icon>tune</mat-icon>
      Filtros de Pesquisa
    </div>
    <div class="filter-body">
      <form [formGroup]="filterForm">
        <div class="filter-grid cols-4">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>CAI</mat-label>
          <input matInput type="text" formControlName="cai" />
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Descrição</mat-label>
          <input matInput type="text" formControlName="itemDescription" />
        </mat-form-field>
        </div>
      </form>
    </div>
    <div class="filter-footer">
      <div class="filter-footer-left">
        <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
          <mat-icon>search</mat-icon><span>Buscar</span>
        </button>
        <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
          <mat-icon>refresh</mat-icon><span>Limpar</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
    </mic-table>
  </div>
</div>
